<template>
  <section class="jwb-module article basic-content tw-py-12">
    <div class="container body-copy">
      <h2 v-if="heading">{{ heading }}</h2>
      <div v-html="content" class="tw-mt-4"></div>
      <div class="flex justify-center">
        <Stats v-if="data" :data="data" />
      </div>
      <div v-if="content2" v-html="content2" class="tw-mt-4"></div>

      <div v-if="buttons" class="button-container">
        <div class="tac">
          <div v-for="button in buttons">
            <a
              v-if="button.button_type === 'internal'"
              class="jwb-button orange-black"
              :href="button.interal"
              >{{ button.button_text }}</a
            >
            <a
              v-if="button.button_type === 'normal'"
              class="jwb-button orange-black"
              :href="button.normal"
              target="_blank"
              >{{ button.button_text }}</a
            >
            <a
              v-if="button.button_type === 'file'"
              class="jwb-button orange-black"
              href="button.file_upload.url"
              target="_blank"
              >{{ button.button_text }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Stats from '@/components/Stats.vue'
export default {
  components: {
    Stats,
  },
  props: {
    heading: { type: String, default: () => {} },
    content: { type: String, default: () => {} },
    content2: { type: String, default: null },
    buttons: { type: [Array, Boolean], default: false },
    data: { type: Object, default: null },
  },
}
</script>
